import { PaymentDetailLoadable } from 'containers/PaymentDetail/PaymentDetailLoadable';
import { PaymentsLoadable } from 'containers/Payments/PaymentsLoadable';
import { InvoiceSubmissionInstructionsLoadable } from
  'containers/InvoiceSubmissionInstructions/InvoiceSubmissionInstructionsLoadable';
import withPaymentListingFlag from 'containers/Payments/withPaymentListingFlag';
import ROUTES, { routesNames } from './constants';

const createPaymentsRoutes = () =>
  [
    {
      path: ROUTES.PAYMENTS,
      onEnter: (nextState, replace) => replace(ROUTES.PENDING_PAYMENTS),
      exact: true,
    },
    {
      path: ROUTES.ALL_PAYMENTS,
      name: routesNames.allPayments,
      component: withPaymentListingFlag(PaymentsLoadable),
      exact: true,
    },
    {
      path: ROUTES.PENDING_PAYMENTS,
      name: routesNames.pendingPayments,
      component: withPaymentListingFlag(PaymentsLoadable),
      exact: true,
    },
    {
      path: `${ROUTES.PAYMENT_DETAIL}:id`,
      name: routesNames.paymentDetail,
      component: withPaymentListingFlag(PaymentDetailLoadable),
      exact: true,
    },
    {
      path: ROUTES.INVOICE_ISSUANCE_DETAILS,
      name: routesNames.invoiceIssuanceDetails,
      component: withPaymentListingFlag(InvoiceSubmissionInstructionsLoadable),
      exact: true,
    },
  ];

export default createPaymentsRoutes;
